// extracted by mini-css-extract-plugin
export default {"Answers":"Answers_Answers__7aegr"};